import { render } from "./ProfileBranchSingle.vue?vue&type=template&id=51ef681c&scoped=true"
import script from "./ProfileBranchSingle.vue?vue&type=script&lang=js"
export * from "./ProfileBranchSingle.vue?vue&type=script&lang=js"

import "./ProfileBranchSingle.vue?vue&type=style&index=0&id=51ef681c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ef681c"]])

export default __exports__